#import "../fragments/instance-info-fragment.graphql"

query GetInstanceInfo {
    sessionInstance {
        ...InstanceInfo
    }
}
